import React, {FC} from 'react';

import {
  AiKnowledgeSourceScrapingJobModel,
  JobTypesEnum,
} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getAllAiKnowledgeSourceScrapingJobs} from '../../../../store/data/jobs/jobsSelectors';
import {AiScrapingJobBanner} from './aiScrapingJobBanner';

/*
 * Component.
 */

export const AiKnowledgeSourceBanners: FC = () => {
  const jobs = useAppSelector(getAllAiKnowledgeSourceScrapingJobs);

  const renderJob = (job: AiKnowledgeSourceScrapingJobModel) => {
    switch (job.type) {
      case JobTypesEnum.AI_KNOWLEDGE_SOURCE_SCRAPER:
        return <AiScrapingJobBanner job={job} />;
      default:
        return null;
    }
  };

  return (
    <>
      {jobs.map((job) => (
        <React.Fragment key={job.id}>{renderJob(job)}</React.Fragment>
      ))}
    </>
  );
};
